import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";

const initialState = {
  werkstoffUebergangsrohr: Number.NaN, // 0 or 1
};

const pileHeadConstructionSlice = createSlice({
  name: "pileHeadConstruction",
  initialState,
  reducers: {
    setPileHeadConstructionState(state, action) {
      state.werkstoffUebergangsrohr = action.payload.werkstoffUebergangsrohr;
    },
    setWerkstoffUebergangsrohr(state, action) {
      state.werkstoffUebergangsrohr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const { setPileHeadConstructionState, setWerkstoffUebergangsrohr } =
  pileHeadConstructionSlice.actions;

export default pileHeadConstructionSlice.reducer;

// werkstoffUebergangsrohr is NaN until a material is picked. NaN !== NaN, so a
// bare useSelector(selectWerkstoffUebergangsrohr) treats the value as changed on
// every store update and re-renders needlessly. Consumers pass Object.is as the
// equality function (Object.is(NaN, NaN) === true) to avoid that.
export const selectWerkstoffUebergangsrohr = (state) =>
  state.pileHeadConstruction.werkstoffUebergangsrohr;
